module.exports = __webpack_public_path__ + "static/media/1.31e954cf.JPG";